module.exports = __webpack_public_path__ + "static/media/Addopen.0d387cc3.svg";